import i18n from 'i18next';

import {
    ChangePasswordRequest,
    SetPasswordParams,
    SetPasswordRequest,
} from '@entities/password/types';
import api from '@shared/api';

const URL = 'uaa/registration/mfa';
const PASSWORD_URL = `${URL}/password`;
const LANGUAGE_HEADERS_PRESET = () => ({headers: {'Accept-Language': i18n.language}});

// export async function createRequest(body: SetPasswordRequest) {
//     const path = `${PASSWORD_URL}/request/create`;
//     return (await api.post(path, body, LANGUAGE_HEADERS_PRESET())).data;
// }

export async function resetRequest(body: SetPasswordRequest) {
    const path = `${PASSWORD_URL}/request/reset`;
    return (await api.post(path, body, LANGUAGE_HEADERS_PRESET())).data;
}

export async function resetAdminRequest(body: SetPasswordRequest) {
    const path = `${PASSWORD_URL}/request/reset-admin`;
    return (await api.post(path, body, LANGUAGE_HEADERS_PRESET())).data;
}

export async function change(body: ChangePasswordRequest) {
    const path = `${PASSWORD_URL}/change`;
    return (await api.post(path, body, LANGUAGE_HEADERS_PRESET())).data;
}

export async function set(body: SetPasswordParams) {
    const path = `${PASSWORD_URL}/create`;
    return (await api.post(path, body, LANGUAGE_HEADERS_PRESET())).data;
}
